/**
 * Shared helpers for /vehicle-location API responses.
 * Backend may return 404 with reason: vehicle_not_registered | vehicle_not_logged_in
 */

export function getVehicleLocationErrorMeta(error) {
  const data = error?.response?.data || error?.data || {};
  const reason = data.reason;
  let title = 'Error';
  let variant = 'danger';

  if (reason === 'vehicle_not_registered') {
    title = 'Vehicle Not Found';
    variant = 'danger';
  } else if (reason === 'vehicle_not_logged_in') {
    title = 'Location Unavailable';
    variant = 'warning';
  }

  const message =
    data.message ||
    'Unable to retrieve vehicle location. Please try again later.';

  return { message, title, variant, reason };
}

export function showVehicleLocationError(vm, error) {
  const { message, title, variant } = getVehicleLocationErrorMeta(error);
  vm.$bvToast.toast(message, {
    title,
    variant,
    solid: true,
    autoHideDelay: 8000,
  });
}

/**
 * Checks live location, shows backend message on failure, navigates on success.
 */
export async function navigateIfVehicleLocationAvailable(
  vm,
  axiosInstance,
  { userId, vehicleId, routeName }
) {
  if (!userId || !vehicleId) {
    showVehicleLocationError(vm, {
      data: {
        message: 'Missing user or vehicle id for tracking.',
        reason: 'vehicle_not_registered',
      },
    });
    return false;
  }

  try {
    const response = await axiosInstance.get(
      `/vehicle-location/${userId}/${vehicleId}`
    );
    if (response.data?.success) {
      await vm.$router.push({
        name: routeName,
        params: {
          userId: String(userId),
          vehicleId: String(vehicleId),
        },
      });
      return true;
    }
    showVehicleLocationError(vm, { response: { data: response.data } });
    return false;
  } catch (error) {
    console.error('Vehicle location error:', error);
    showVehicleLocationError(vm, error);
    return false;
  }
}
